.imgur {
    iframe {
        display: block;
        margin: 0 auto !important;
    }
}